import { Pensao } from './../entities/pensao';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AtualizarNumeroProcesoDto, DadosInstituidorDto, DadosRequerenteDto } from '@sgprev-dtos';
import { DadosPensao } from '@sgprev-entities';
import { environment } from 'environments/environment';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { BuscaProcessoDto } from '../dtos/busca-processo.dto';
import { ConsultaBeneficioDto, TramitacaoProcessoDto } from '../dtos/consulta-beneficio.dto';
import { HistoricoMovimentacao } from '../entities/historico-movimentacao';
import { AuthenticationService } from './authentication.service';


@Injectable({
    providedIn: 'root'
})
export class PensaoService {

    private apiUrl = `${environment.API_URL}/pensao`;

    private _dadosPensao = new BehaviorSubject<DadosPensao>(new DadosPensao());
    public shareDadosPensao$ = this._dadosPensao.asObservable();

    constructor(
        private httpClient: HttpClient
    ) { }

    public get dadosPensao(): DadosPensao {
        return this._dadosPensao.getValue();
    }

    public set dadosPensao(value: DadosPensao) {
        this._dadosPensao.next(value);
    }

    

    buscarProcessos(pesquisa?: BuscaProcessoDto, page = 0, size = 10): Observable<any> {
        let params = new HttpParams().set('page', page).set('size', size);
    
        if (pesquisa) {
          if (pesquisa.numeroProcesso) { params = params.append('numeroProcesso', pesquisa.numeroProcesso); }
          if (pesquisa.matricula) { params = params.append('matricula', pesquisa.matricula); }
          if (pesquisa.cpf) { params = params.append('cpf', pesquisa.cpf); }
          if (pesquisa.nome) { params = params.append('nome', pesquisa.nome); }
          if (pesquisa.fase) { params = params.append('fase', pesquisa.fase.toString()); }
          if (pesquisa.status) { params = params.append('status', pesquisa.status.toString()); }
          if (pesquisa.orgaoOrigem) { params = params.append('orgaoOrigem', pesquisa.orgaoOrigem.toString()); }
          if (pesquisa.localAtual) { params = params.append('localAtual', pesquisa.localAtual.toString()); }
        }
    
        return this.httpClient.get<any>(`${this.apiUrl}/pesquisar-processo`, { params }).pipe(
          catchError(error => {
            console.error('Erro ao buscar processos', error);
            return throwError(() => new Error('Algo deu errado ao buscar os processos'));
          })
        );
      }


    baseRubricas(id: number): Observable<any> { return this.httpClient.get(`${this.apiUrl}/${id}/base-rubricas`); }
    salvarBaseRubricas(id: number, dados: any): Observable<any> { return this.httpClient.put(`${this.apiUrl}/${id}/base-rubricas`, dados); }
    tentativaAbertura(id: number): Observable<any> { return this.httpClient.get(`${this.apiUrl}/${id}/abertura`); }
    conciliarAbertura(id: number, nup: string, justificativa: string): Observable<any> { return this.httpClient.post(`${this.apiUrl}/${id}/abertura/conciliar`, {nup, justificativa}); }
    autorizarReenvioAbertura(id: number, justificativa: string): Observable<any> { return this.httpClient.post(`${this.apiUrl}/${id}/abertura/autorizar-reenvio`, {justificativa}); }
    locaisProcesso(): Observable<any[]> { return this.httpClient.get<any[]>(`${this.apiUrl}/processo/locais`); }
    tramitacoes(id: number): Observable<TramitacaoProcessoDto[]> { return this.httpClient.get<TramitacaoProcessoDto[]>(`${this.apiUrl}/${id}/tramitacoes`); }
    tramitar(id: number, idLocalDestino: number, observacao: string): Observable<TramitacaoProcessoDto> {
      return this.httpClient.post<TramitacaoProcessoDto>(`${this.apiUrl}/${id}/tramitar`, {idLocalDestino, observacao});
    }
    /** Cabeçalho e movimentações da aba "14 - Consultar Benefício". */
    consulta(id: number): Observable<ConsultaBeneficioDto> { return this.httpClient.get<ConsultaBeneficioDto>(`${this.apiUrl}/${id}/consulta`); }

    public salvarRequerentes(requerentes: DadosRequerenteDto[]): Observable<any> {
        this.dadosPensao.requerentes = requerentes;
        return this.httpClient.post(`${this.apiUrl}/requerentes`, requerentes); // TODO: fix observable type );
    }

    public salvarHistoricoMovimentacao(historicoMovimentacao: HistoricoMovimentacao): Observable<any> {
      return this.httpClient.post(`${this.apiUrl}/movimentacao/salvar`, historicoMovimentacao);
    }


    public salvarInstituidor(dadosInstituidor: DadosInstituidorDto): Observable<any> {
        //this.dadosPensao.dadosInstituidor = dadosInstituidor;
        //return this.httpClient.post(`${this.apiUrl}/instituidor`, dadosInstituidor);
         this.dadosPensao.dadosInstituidor = dadosInstituidor;

    return this.httpClient.post(`${this.apiUrl}/instituidor`, dadosInstituidor);
    }


    getListagemRequerimento(page: number, size: any): Observable<any> {
        return this.httpClient.get<any>(`${this.apiUrl}/todos?page=${page}&size=${size}`);
    }


  public getRequerimentoById(pensaoId: number): Observable<Pensao> {
      return this.httpClient.get<Pensao>(`${this.apiUrl}/${pensaoId}`);
  }

  public adicionarNumeroProcesso(dadosAtualizados: AtualizarNumeroProcesoDto): Observable<Pensao> {
    return this.httpClient.patch<Pensao>(`${this.apiUrl}/${dadosAtualizados.id}/adicionar-numero-processo`, dadosAtualizados);
  }

  public abrirProcesso(idPensao: number, tipoAssuntoProcesso: string): Observable<Pensao> {
    return this.httpClient.patch<Pensao>(
      `${this.apiUrl}/${idPensao}/adicionar-numero-processo`,
      { tipoAssuntoProcesso, atestado: true }
    );
  }

  public getTiposAssunto(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.apiUrl}/processo/tipos-assunto`);
  }
}
